import { ADD_HOLDING_PACKAGES,
    ADD_HOLDING_PACKAGES_SUCCESS,
    ADD_HOLDING_PACKAGES_FAIL,
    GET_HOLDING_REPORT,
    GET_HOLDING_REPORT_SUCCESS,
    GET_HOLDING_REPORT_FAIL,
    GET_HOLDING_KEY,
    GET_HOLDING_KEY_SUCCESS,
    GET_HOLDING_KEY_FAIL,
    CANCEL_BATCH,
    CANCEL_BATCH_SUCCESS,
    CANCEL_BATCH_FAIL,
    CANCEL_TNO,
    CANCEL_TNO_SUCCESS,
    CANCEL_TNO_FAIL,
    ADD_HOLDING_PACKAGE_BY_BAGS,
    ADD_HOLDING_PACKAGE_BY_BAGS_SUCCESS,
    ADD_HOLDING_PACKAGE_BY_BAGS_FAIL,
    HANDLE_BLOCK_BATCH } from '../actions/types';

const initialState = {
    handleBlockBatch: '',
    addHoldingPackageByBagsLoading: false,
    addHoldingPackageByBags: [],
    addHoldingPackageByBagsError: false,
    addHoldingPackagesLoading: false,
    addHoldingPackages: [],
    addHoldingPackagesError: false,
    getHoldingReportLoading: false,
    getHoldingReport: [],
    getHoldingReportError: false,
    getHoldingKeyLoading: false,
    getHoldingKey: '',
    getHoldingKeyError: false,
    cancelBatchLoading: false,
    cancelBatch: [],
    cancelBatchError: false,
    cancelTnoLoading: false,
    cancelTno: [],
    cancelTnoError: false,
}

export default function hpmReducer(state = initialState, action){
    switch(action.type){
        case HANDLE_BLOCK_BATCH:
            return {
                handleBlockBatch: action.payload
            }
        case ADD_HOLDING_PACKAGE_BY_BAGS:
            return {
                ...state,
                addHoldingPackageByBagsLoading: true,
            }
        case ADD_HOLDING_PACKAGE_BY_BAGS_SUCCESS:
            return {
                ...state,
                addHoldingPackageByBags: action.payload,
                addHoldingPackageByBagsLoading: false
            }
        case ADD_HOLDING_PACKAGE_BY_BAGS_FAIL:
            return {
                ...state,
                addHoldingPackageByBagsLoading: false,
                addHoldingPackageByBagsError: action.payload
            }
        case ADD_HOLDING_PACKAGES:
            return {
                ...state,
                addHoldingPackagesLoading: true,
            }
        case ADD_HOLDING_PACKAGES_SUCCESS:
            return {
                ...state,
                addHoldingPackages: action.payload,
                addHoldingPackagesLoading: false
            }
        case ADD_HOLDING_PACKAGES_FAIL:
            return {
                ...state,
                addHoldingPackagesLoading: false,
                addHoldingPackagesError: action.payload
            }
        case GET_HOLDING_REPORT:
            return {
                ...state,
                getHoldingReportLoading: true
            }
        case GET_HOLDING_REPORT_SUCCESS:
            return {
                ...state,
                getHoldingReport: action.payload,
                getHoldingReportLoading: false
            }
        case GET_HOLDING_REPORT_FAIL:
            return {
                ...state,
                getHoldingReportLoading: false,
                getHoldingReportError: action.payload
            }
        case GET_HOLDING_KEY:
            return {
                ...state,
                getHoldingKeyLoading: true,
            }
        case GET_HOLDING_KEY_SUCCESS:
            return {
                ...state,
                getHoldingKey: action.payload,
                getHoldingKeyLoading: false
            }
        case GET_HOLDING_KEY_FAIL:
            return {
                ...state,
                getHoldingKeyLoading: false,
                getHoldingKeyError: action.payload
            }
        case CANCEL_BATCH:
            return {
                ...state,
                cancelBatchLoading: true,
            }
        case CANCEL_BATCH_SUCCESS:
            return {
                ...state,
                cancelBatch: action.payload,
                cancelBatchLoading: false
            }
        case CANCEL_BATCH_FAIL:
            return {
                ...state,
                cancelBatchLoading: false,
                cancelBatchError: action.payload
            }
        case CANCEL_TNO:
            return {
                ...state,
                cancelTnoLoading: true,
            }
        case CANCEL_TNO_SUCCESS:
            return {
                ...state,
                cancelTno: action.payload,
                cancelTnoLoading: false
            }
        case CANCEL_TNO_FAIL:
            return {
                ...state,
                cancelTnoLoading: false,
                cancelTnoError: action.payload
            }
        default:
            return state;
    }
}